import { themeColors } from "../components/chartTheme";

export const getSystolicColor = (value: number): string => {
  if (value < 90) {
    return themeColors.warning;
  }
  if (value >= 90 && value <= 120) {
    return themeColors.success;
  }
  if (value >= 121 && value <= 130) {
    return themeColors.warning;
  }
  return themeColors.error;
};

export const getDiastolicColor = (value: number): string => {
  if (value < 60) {
    return themeColors.warning;
  }
  if (value >= 60 && value <= 80) {
    return themeColors.success;
  }
  if (value >= 81 && value <= 90) {
    return themeColors.warning;
  }
  return themeColors.error;
};
